import { useEffect, useState } from 'react'
import DaumPostcode from 'react-daum-postcode'
import { isMobile } from 'react-device-detect'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { getOrderDetail, putDeliveries } from '../../api/orderHistory'
import { BtnWhiteRounded } from '../../components/Button'
import { InputText, InputTextDiv, InputTextSection, InputTextTitle } from '../../components/input/InputText'
import { InputTextArea } from '../../components/input/InputTextArea'
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar'
import OrderRecentCenterModal from '../../components/order/OrderRecentCenterModal'
import OrderRecentModal from '../../components/order/OrderRecentModal'
import { PageTitle } from '../../components/title/PageTitle'
import { SectionTitle } from '../../components/title/SectionTitle'
import Dropdown from '../../components/dropdown/Dropdown'

export default function AddressChange() {
  const [receiveName, setReceiveName] = useState<string>('')
  const [receiveZip, setReceiveZip] = useState<string>('')
  const [receiveAddress_1, setReceiveAddress_1] = useState<string>('')
  const [receivePhone, setReceivePhone] = useState<string>('')
  const [receiverDetailAddress, setReceiveDetail] = useState<string>('')
  const [receiverJibun, setReceiverJibun] = useState<string>('')
  const [modalSelectAddress, setModalSelectAddress] = useState<any>()
  const [recentModal, setRecentModal] = useState<boolean>(false)
  const [visible, setVisible] = useState<boolean>(false)
  const [orderAddress, setOrderAddress] = useState<any>()
  const [receiverMemo, setReceiverMemo] = useState<string>('문 앞에 놓아주세요')

  const deliveryMemo = ['문 앞에 놓아주세요', '부재 시 연락 부탁드려요', '배송 전 미리 연락해 주세요', '직접 입력']
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (location) {
      getOrderDetail(location.state.orderNo).then((res) => {
        setOrderAddress(res.data.shippingAddress)
      })
    }
  }, [location])

  useEffect(() => {
    if (orderAddress) {
      setReceiveZip(orderAddress.receiverZipCd)
      setReceiveAddress_1(orderAddress.receiverAddress)
      setReceiveDetail(orderAddress.receiverDetailAddress)
      setReceiveName(orderAddress?.receiverName ? orderAddress?.receiverName : '')
      setReceivePhone(orderAddress?.receiverContact1.replaceAll('-', ''))
    }
  }, [orderAddress])

  useEffect(() => {
    if (modalSelectAddress !== undefined) {
      setReceiveZip(modalSelectAddress.receiverZipCd)
      setReceiveAddress_1(modalSelectAddress.receiverAddress)
      setReceiveDetail(modalSelectAddress.receiverDetailAddress)
      setReceiveName(modalSelectAddress?.receiverName ? modalSelectAddress?.receiverName : '')
      setReceivePhone(modalSelectAddress?.receiverContact1.replaceAll('-', ''))
    }
  }, [modalSelectAddress, orderAddress])

  const handleComplete = (data: any) => {
    let fullAddress = data.address
    let extraAddress = ''

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname
      }
      if (data.buildingName !== '') {
        extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName
      }
      fullAddress += extraAddress !== '' ? ` (${extraAddress})` : ''
    }
    setReceiveZip(data.zonecode)
    setReceiveAddress_1(data.address)
    // setReceiveDetail("");
    setReceiverJibun(data.jibunAddress)
    setVisible(false)
  }
  return (
    <div className='main_wrap'>
      <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap'}>
        <MyShoppingSideBar />
        <div className='myshopping_wrap'>
          <PageTitle>배송지 변경</PageTitle>

          <div className='delivery_address_wrap'>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 20,
              }}
            >
              <SectionTitle style={{ margin: 0 }}>배송지 정보</SectionTitle>
              <BtnWhiteRounded
                style={{ marginLeft: 'auto' }}
                onClick={() => {
                  setRecentModal(true)
                }}
              >
                최근 배송지
              </BtnWhiteRounded>
            </div>
            <InputTextSection>
              <InputTextDiv>
                <InputTextTitle>받으시는 분</InputTextTitle>
                <InputText
                  placeholder='성함을 입력해 주세요.'
                  value={receiveName}
                  onChange={(e) => {
                    setReceiveName(e.target.value)
                  }}
                ></InputText>
              </InputTextDiv>
              <InputTextDiv>
                <InputTextTitle style={{ alignSelf: 'start', marginTop: 10 }}>주소</InputTextTitle>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    gap: 8,
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '8px',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        gap: '8px',
                      }}
                    >
                      <input
                        type='text'
                        id='address_1'
                        name='address_1'
                        readOnly
                        value={receiveZip}
                        style={{
                          fontSize: '14px',
                          fontWeight: '500',
                          lineHeight: '20px',
                          color: 'var(--colBlack)',
                          padding: '10px 14px',
                          width: 'calc(100% - 108px)',
                          borderRadius: '5px',
                          border: '1px solid var(--colGray3)',
                          backgroundColor: 'var(--colGray1)',
                        }}
                      />
                      <button
                        type='button'
                        id='address_btn'
                        style={{
                          fontSize: '13px',
                          fontWeight: '500',
                          lineHeight: '16px',
                          color: 'var(--colWhite)',
                          padding: '12px 14px',
                          borderRadius: '5px',
                          width: '100px',
                          backgroundColor: 'var(--colBlack)',
                          border: '0',
                          fontFamily: 'Pretendard, sans-serif',
                        }}
                        onClick={() => {
                          setVisible(true)
                        }}
                      >
                        우편번호 찾기
                      </button>
                      {visible && (
                        <>
                          <div
                            className='dim'
                            style={{
                              display: visible ? 'block' : 'none',
                              width: '100%',
                              height: '100vh',
                              zIndex: '20',
                              backgroundColor: 'rgba(0, 0, 0, 0.6)',
                              position: 'fixed',
                              top: '0',
                              left: '0',
                              overflow: 'hidden',
                            }}
                          >
                            <div className='postcode_find_wrap'>
                              <button
                                // style={closeButton}
                                title='닫기'
                                onClick={() => setVisible(false)}
                                style={{
                                  position: 'absolute',
                                  width: '48px',
                                  height: '48px',
                                  top: '0',
                                  right: '0',
                                  zIndex: '30',
                                  padding: '0',
                                  margin: '0',
                                  border: '0',
                                  background: 'transparent',
                                }}
                              >
                                <img
                                  src='/images/icon_close_btn.png'
                                  alt=''
                                  style={{
                                    width: '100%',
                                  }}
                                />
                              </button>
                              <div
                                style={{
                                  background: 'var(--colWhite)',
                                  position: 'absolute',
                                  top: 'calc(50% + 20px)',
                                  left: '50%',
                                  transform: 'translate(-50%,-50%)',
                                  width: '100%',
                                  zIndex: 9999,
                                  height: 390,
                                  maxWidth: '95%',
                                  border: '1px solid var(--colGray3)',
                                }}
                              >
                                <DaumPostcode
                                  onComplete={handleComplete}
                                  style={{ height: '100%', margin: `0 auto` }}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                    <input
                      type='text'
                      id='address_2'
                      name='address_2'
                      readOnly
                      value={receiveAddress_1}
                      style={{
                        fontSize: '14px',
                        fontWeight: '500',
                        lineHeight: '20px',
                        color: 'var(--colBlack)',
                        padding: '10px 14px',
                        width: '100%',
                        borderRadius: '5px',
                        border: '1px solid var(--colGray3)',
                        backgroundColor: 'var(--colGray1)',
                      }}
                    />
                  </div>
                  <input
                    type='text'
                    id='address_3'
                    name='address_3'
                    placeholder='상세주소를 입력해주세요'
                    value={receiverDetailAddress}
                    onChange={(e) => {
                      setReceiveDetail(e.target.value)
                    }}
                    style={{
                      fontSize: '14px',
                      fontWeight: '500',
                      lineHeight: '24px',
                      color: 'var(--colBlack)',
                      padding: '8px 16px',
                      width: '100%',
                      borderRadius: '5px',
                      border: '1px solid var(--colGray3)',
                      backgroundColor: 'var(--colWhite)',
                    }}
                  />
                </div>
              </InputTextDiv>
              <InputTextDiv>
                <InputTextTitle>휴대폰 번호</InputTextTitle>
                <InputText
                  placeholder='‘-’을 제외하고 입력해 주세요.'
                  value={receivePhone}
                  onChange={(e) => {
                    setReceivePhone(e.target.value)
                  }}
                ></InputText>
              </InputTextDiv>

              <InputTextDiv>
                <InputTextTitle style={{ alignSelf: 'start', marginTop: 10 }}>배송 메시지</InputTextTitle>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    gap: 8,
                  }}
                >
                  <Dropdown setReceiverMemo={setReceiverMemo} data={deliveryMemo}></Dropdown>
                  {receiverMemo === '직접 입력' ? (
                    <InputTextArea placeholder='요청사항을 입력해 주세요. (30자 이내)' maxLength={30}></InputTextArea>
                  ) : null}
                </div>
              </InputTextDiv>
            </InputTextSection>
            <div className='bottom_buttons'>
              <button
                type='button'
                className='btn_cancel'
                onClick={() => {
                  navigate(-1)
                }}
              >
                취소
              </button>
              <button
                type='button'
                className='btn_confirm'
                onClick={() => {
                  if (!receiveName) {
                    alert('받으시는 분 성함을 확인해주세요')
                  } else if (!receiveZip) {
                    alert('주소를 확인해주세요')
                  } else if (!receivePhone) {
                    alert('휴대폰 번호를 확인해주세요')
                  } else {
                    putDeliveries(
                      location.state.orderNo,
                      receiveZip,
                      receiveAddress_1,
                      receiverJibun,
                      receiverDetailAddress,
                      receiveName,
                      receivePhone,

                      receiverMemo
                    ).then((res) => {
                      alert('배송지 변경이 완료되었습니다.')
                      navigate(`/orderdetail/${location.state.orderNo}`)
                    })
                  }
                }}
              >
                확인
              </button>
            </div>
          </div>

          {recentModal ? (
            isMobile ? (
              <OrderRecentModal
                setModalSelectAddress={setModalSelectAddress}
                setIsModal={setRecentModal}
              ></OrderRecentModal>
            ) : (
              <OrderRecentCenterModal
                setModalSelectAddress={setModalSelectAddress}
                setIsModal={setRecentModal}
              ></OrderRecentCenterModal>
            )
          ) : null}
        </div>
      </div>
    </div>
  )
}
const SectionDiv = styled.div`
  padding: 24px 20px;
  @media screen and (min-width: 768px) {
    padding: 32px 0 0 0;
  }
`
